const MyButton = ({name, grey, width, height, size, data, blue, type = "button", onClick}) => {
  
  const handleClick = (e) => {
    if (type === 'submit') {
      // Let form submission happen normally, no mailto override
      if (onClick) onClick(e);
      return;
    }

    if (!data) return;

    const subject = encodeURIComponent('Data from React Button');
    const body = encodeURIComponent(JSON.stringify(data, null, 2));
    const mailtoLink = `mailto:job@nets.tj?subject=${subject}&body=${body}`;

    window.location.href = mailtoLink; // opens user's email client
  };

  return (
    <button
    type={type}
      className='MyButton'
      style={{
        background: grey ? '#F2F3F7' : blue ? '#21BBEF' :'#EA3E2A',
        width,
        height,
        color: grey ? '#202020' : '#FFF',
        fontSize: size || ''
      }}
      onClick={handleClick}
    >
      {name}
    </button>
  );
}

export default MyButton;
